import { useAtomValue } from 'jotai';
import { chatbotConfigState } from '../state/config/ChatbotConfigState';
import { TRANSLATIONS } from '../utils/constants/translations';

function interpolate(template, vars = {}) {
    return String(template || '').replace(/\{(\w+)\}/g, (_, key) => (
        vars[key] !== undefined && vars[key] !== null ? String(vars[key]) : ''
    ));
}

export function useAppTranslation() {
    const config = useAtomValue(chatbotConfigState);
    const currentLang = config?.language === 'en' ? 'en' : 'de';
    const t = TRANSLATIONS[currentLang] || TRANSLATIONS.de;

    const tr = (key, vars = {}) => interpolate(t?.[key] ?? key, vars);

    return {
        t,
        tr,
        lang: currentLang,
    };
}
